import { AvatarList } from '@opallabs/lapidary'
import * as styles from './styles'
import { useLiveViewers } from './useLiveViewers'

/**
 * Live facepile of who else is viewing the same entity, in real time.
 *
 * @example <LiveViewers entityType="plans" />                   // the plans list
 * @example <LiveViewers entityType="plan" entityId={planId} />  // a single plan
 */
export const LiveViewers = ({
  entityType,
  entityId,
}: {
  entityType: string
  entityId: string | null
}) => {
  const items = useLiveViewers(entityType, entityId)

  if (items.length === 0) return null

  return (
    <div className="live-viewers" css={styles.container}>
      <AvatarList
        avatarSize={24}
        items={items}
        maxDisplayedItems={4}
        sortMode="presorted"
      />
    </div>
  )
}
